import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { AddButton, DeleteButton } from '../../../Res/BaseButton';
import { getKey, uuid } from '../../../../../item/ItemTools';
import { setTD, setTDSelect, setTH, setTDDate, setDatePicker } from '../../../../../item/ItemTableList';
import { RespTeamHistory } from '../../../../../item/MyStat/ItemTeam';
import { get_player_description_string, RespPlayerHistory } from '../../../../../item/MyStat/ItemPlayerHistory';
import { PlayerHistoryDate } from './PlayerHistoryDate';
import { api_getLeagueTeamList } from '../../../../../api/MyStat/apiTeam';
import { DatePickerInput } from 'rc-datepicker';
import { BorderColor, SignalCellularNullTwoTone } from '@material-ui/icons';


export function PlayerHistory({ ph, action, pdAction, errAction }) {
  const [player_history, set_player_history] = useState(null)
  const [league_id, set_league_id] = useState('')
  const [player_id, set_player_id] = useState('')
  const [title, set_title] = useState("")
  const [items, set_items] = useState([])
  const [teams, set_teams] = useState([])
  const [player_debut, set_player_debut] = useState("")
  const [player_debut_err, set_player_debut_err] = useState(false)

  const [html, setHtml] = useState(<></>)

  var team_duration_start_onChange_err = {}
  var team_duration_end_onChange_err = {}

  useEffect(() => {
    if (ph !== undefined && ph !== player_history) {
      console.log(ph)
      set_player_history(ph)
      set_title(ph.league_name + " 歷程管理")
      set_league_id(ph.league_id)
      set_player_id(ph.player_id)
      if(ph.player_debut !== null)
        set_player_debut(moment(ph.player_debut).format('YYYY-MM-DD'))
      set_items(JSON.parse(ph.items))
    }
  }, [ph])

  useEffect(() => {
    if (items.length > 0) {
      console.log(items)
      setItemBox()
      action(league_id, items, player_debut)
    }
  }, [items, teams])

  useEffect(() => {
    if (league_id !== "") {
      getTeamList()
    }
  }, [league_id])

  function getTeamList() {
    api_getLeagueTeamList({
      league_id,
      success: (obj) => {
        console.log(obj)
        set_teams(obj.list)
      },
      failure: (err) => {
        console.log(err)
      }
    })
  }

  function addPlayerHistory() {

  }

  function addItem() {
    console.log(items)
    var tItems = items.filter(item => {
      return item.player_history !== ""
    })
    console.log(tItems)
    tItems.push(new RespPlayerHistory({
      league_id,
      player_id,
      player_history_id: uuid(32, 64),
    }))
    console.log(tItems)
    set_items(tItems)
  }

  function delItem(id) {
    console.log(id)
    var tItems = items.filter(item => {
      return item.player_history !== id
    })
    set_items(tItems)
  }


  function team_id_action(k, v) {
    // console.log(k)
    // console.log(v)
    // console.log(teams)
    var team = teams.filter(team => {
      return team.team_id === v
    })
    var team_name = ""
    if (team.length > 0) {
      team_name = team[0].team_name
    }
    var [...tItems] = items
    for (let e of tItems) {
      if (e.player_history_id === k) {
        e.team_id = v;
        e.team_name = team_name
      }
    }
    // console.log(tItems)
    set_items(tItems)
  }

  function team_history_id_action(k, v) {
    // console.log(k)
    // console.log(v)

    var [...tItems] = items
    for (let e of tItems) {
      if (e.player_history_id === k) e.team_history_id = v;
    }
    // console.log(tItems)
    set_items(tItems)
  }

  function player_number_action(k, v) {
    var [...tItems] = items
    for (let e of tItems) {
      if (e.player_history_id === k) e.player_number = v;
    }
    set_items(tItems)
  }

  function check_duration_err(){
    var sArray = Object.values(team_duration_start_onChange_err);  
    var fsEmpty = sArray.filter((item) => {
      return item;
    });

    var eArray = Object.values(team_duration_start_onChange_err);  
    var eEmpty = eArray.filter((item) => {
      return item;
    });

    if(errAction !== undefined){
      errAction((fsEmpty.length + eEmpty.length)>0)
    }
  }

  function team_duration_start_onChange(k, v) {
    console.log(k)
    console.log(v)
    var [...tItems] = items
    try {
      for (let e of tItems) {
        if (e.player_history_id === k) {
          // if (v === "Invalid date") {
          //   // e.team_duration_start = null
          //   e.team_duration_start_err = true
          // } else {
          //   e.team_duration_start = moment(v).format('YYYY-MM-DD');
          //   e.team_duration_start_err = false
          // }
          e.team_duration_start = v
        }
      }
      set_items(tItems)
      console.log('tItems')
      console.log(tItems)
    } catch (error) {

    }
  }
  function team_duration_start_onChange_errAction(id, err){
    team_duration_start_onChange_err[id] = err
    // console.log(team_duration_start_onChange_err)
    // errAction(team_duration_start_onChange_err)
    check_duration_err()
  }


  function team_duration_end_onChange(k, v) {
    console.log(k)
    console.log(v)
    var [...tItems] = items
    try {
      for (let e of tItems) {
        if (e.player_history_id === k) {
          // if (v === "Invalid date") {
          //   // e.team_duration_end = null
          //   e.team_duration_end_err = true
          // } else {
          //   e.team_duration_end = moment(v).format('YYYY-MM-DD');
          //   e.team_duration_end_err = false
          // }
          e.team_duration_end = v
        }
      }
      set_items(tItems)
      // console.log(tItems)
    } catch (error) {

    }

  }

  function team_duration_end_onChange_errAction(id, err){
    team_duration_end_onChange_err[id] = err
    check_duration_err()
  }

  const player_debut_onChange = (k, v, dateString) => {
    console.log(v)
    console.log(dateString)
    var val = v
    if (v === "Invalid date") {
      // setBirthError(true)
      set_player_debut_err(true)
      val = null
    } else {
      // setBirthError(false)
      set_player_debut(v)
      set_player_debut_err(false)
      pdAction(league_id, val)
    }
  }


  function setItemBox() {
    setHtml(<>
      {items.map((item, index) => (
        getItemBox(item, index)
      ))}
    </>)
  }

  function getItemBox(item, index) {
    // console.log(item)
    // console.log(teams)
    var historys = teams.filter(team => {
      return team.team_id === item.team_id
    })
    var team_historys = []
    if (historys.length > 0) {
      try {
        team_historys = JSON.parse(historys[0].team_history)
        team_historys.unshift({ team_history_id: "", team_name: item.team_name })
      } catch (error) {
        // console.log(error)
      }
    }
    // console.log(team_historys)
    // var history = (item.team_history)
    var html =
      <tr key={getKey({})}>
        {setTDSelect({ content: item.team_id, attr: teams, v: 'team_id', n: 'team_name', id: item.player_history_id, action: team_id_action })}
        {setTDSelect({ content: item.team_history_id, attr: team_historys, v: 'team_history_id', n: 'team_name', id: item.player_history_id, action: team_history_id_action, hasBlank: false })}
        {setTD({ content: item.player_number, isEdit: true, id: item.player_history_id, action: player_number_action })}
        {setTDDate({ content: item.team_duration_start, isEdit: true, id: item.player_history_id, action: team_duration_start_onChange , errAction:team_duration_start_onChange_errAction})}
        {item.player_currently === 1
          ? setTD({ content: "" })
          : setTDDate({ content: item.team_duration_end, isEdit: true, id: item.player_history_id, action: team_duration_end_onChange , errAction:team_duration_end_onChange_errAction})}
        {setTD({ content: get_player_description_string(item.player_currently), isEdit: false, id: item.player_currently, })}

      </tr>
    return html
  }


  return (
    <div className="panel panel-default" key={getKey({})} >
      <div className="panel-heading">
        <div className="row m-xs">
          <div className="col-sm-8">
            <h3><p className="text-success">{title}</p></h3>
          </div>
          <div className="col-sm-4">
            <div className="row text-right">
              <AddButton name={"新增一筆歷史紀錄"} btnStyle={'btn-primary'} action={addItem} />
            </div>
          </div>

        </div>
      </div>
      <div className="panel-body">
        <div className="row">
          <div className="col-lg-12">
            <table className="table table-bordered">
              <thead>
                <tr>
                  {setTH({ name: "歸屬球隊", size: 2 })}
                  {setTH({ name: "歷史名稱", size: 2 })}
                  {setTH({ name: "背號", size: 2 })}
                  {setTH({ name: "起始日期", size: 2 })}
                  {setTH({ name: "結束日期", size: 2 })}
                  {setTH({ name: "描述", size: 2 })}
                </tr>
              </thead>
              <tbody>
                {html}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="col-sm-8">
              <p className="text-danger">系統是以賽事紀錄當時，球員出賽的球隊為主，這裡只是提供資訊而已</p>

            </div>
            <div className="col-sm-1">
              <div className="row text-right">初登板日期</div>
            </div>

            <div className="col-sm-3" >
              <PlayerHistoryDate  date={player_debut} action={ player_debut_onChange} />
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}